import { useCancelEditQuoteData } from "./cancel-edit-modal-content.hooks";
import { ConfirmationModalContentProps } from "./cancel-edit-modal-content.type";
import ButtonWrapper from "../button-wrapper/button-wrapper";
import ModalWrapper from "../modal/modal-wrapper";
import RichText from "../rich-text/rich-text";

export default function CancelEditModalContent(
  props: Readonly<ConfirmationModalContentProps>
) {
  const {
    isCancelEditOpen,
    setIsCancelEditOpen,
    isShowDescription = true,
    isRichTextAvailable = false,
    handleConfirmBtnClick,
    handleCancelBtnClick,
  } = props;
  const { data } = useCancelEditQuoteData();

  return (
    <ModalWrapper
      isOpen={isCancelEditOpen}
      setIsOpen={setIsCancelEditOpen}
      className="md:p-spacing-xxxl p-spacing-l md:max-w-[416px] max-w-[327px] w-full "
    >
      <div data-testid="confirmation-modal-content">
        <h1
          className="text-text-title font-dmserif font-header-font text-2xs-font-size md:text-3xl sm:text-header-font-size-small sm:leading-custom-size-md
                md:leading-custom-size-xl mb-spacing-s"
        >
          {data?.modalTitle}
        </h1>
        {isShowDescription && !isRichTextAvailable && (
          <p className="leading-custom-size-lg text-confirmation-body sm:text-2xs-font-size">
            {data?.modalDescription}
          </p>
        )}
        {isShowDescription && isRichTextAvailable && (
          <RichText
            richText={data?.modalDescription}
            className="leading-custom-size-lg text-confirmation-body sm:text-2xs-font-size"
          />
        )}
        <div className="flex md:flex-row flex-col mt-spacing-l gap-x-spacing-xs">
          <ButtonWrapper
            hierarchy="primary"
            label={data?.ctaButtonLabel}
            id=" "
            className="md:mb-0 mb-2 !h-[48px] md:w-[148px] w-full !text-confirmation-body leading-[18px]"
            isRightIcon={false}
            onClick={handleConfirmBtnClick}
          />
          <ButtonWrapper
            hierarchy="secondary"
            label={data?.backButtonLabel}
            id=" "
            className="md:mb-0 mb-2 !h-[48px] md:w-[148px] w-full !text-confirmation-body leading-[18px]"
            isRightIcon={false}
            onClick={handleCancelBtnClick}
          />
        </div>
      </div>
    </ModalWrapper>
  );
}
